import { footerColumns } from '@/mocks/home';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-plant-line text-lg"></i>
              </span>
              <span className="font-heading text-xl">香蕉社区</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-100/80 max-w-md">
              本站围绕香蕉社区官网、网址、首页与最新地址提供入口与新地址的整理说明。
              内容仅作一般性参考，不代替官方发布，请在访问前自行核实来源。
            </p>
            <p className="mt-4 text-xs text-background-200/70 max-w-md leading-relaxed">
              免责声明：本站为独立信息整理页，不提供任何站点的直接跳转，不代表官方立场，也不对第三方页面的内容与行为负责。
            </p>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="md:col-span-3 lg:col-span-2">
              <h3 className="font-heading text-base text-background-50">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      className="text-sm text-background-100/75 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-4 lg:col-span-3">
            <h3 className="font-heading text-base text-background-50">阅读提醒</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-100/75">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-300"></i>
                <span>入口信息以官方渠道公布为准</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-300"></i>
                <span>不轻信来源不明的地址与短链</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-accent-300"></i>
                <span>遇到异常页面立即退出</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">© {year} 香蕉社区信息整理页 · 仅供查阅参考</p>
          <a href="#top" className="inline-flex items-center gap-1.5 text-xs text-background-100/80 hover:text-primary-300 transition-colors cursor-pointer">
            <i className="ri-arrow-up-line"></i>
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}